import { useMutation, useQuery } from "@tanstack/react-query";
import { MappingType } from "../config/enums/MappingSourceType.enum";
import { ApiServiceErr, axiosApi } from "./apiService";

interface CreateMappingIngredientData {
  sourceId: string;
  ownerId: string;
  ingredientId: string;
  supplierId: string;
  ingredientName: string;
  supplierName: string;
  mappingType: MappingType;
}

export const useGetMappingIngredientById = (id: string) => {
  return useQuery<CreateMappingIngredientData, ApiServiceErr>(
    ["mapping-ingredient", id],
    async () => {
      const response = await axiosApi.get(`/mapping-ingredient/${id}`);
      return response.data;
    },
    {
      enabled: !!id
    }
  );
};

export const usePostMappingIngredientData = () => {
  return useMutation<string, ApiServiceErr, CreateMappingIngredientData>(async data => {
    const response = await axiosApi.post(`/mapping-ingredient`, data);
    return response.data;
  });
};

export const useUpdateMappingIngredientData = () => {
  return useMutation<string, ApiServiceErr, { id: string; data: CreateMappingIngredientData }>(
    async ({ id, data }) => {
      const response = await axiosApi.put(`/mapping-ingredient/${id}`, data);
      return response.data;
    }
  );
};

export const useDeleteMappingIngredient = () => {
  return useMutation<string, ApiServiceErr, string>(async (id: string) => {
    const response = await axiosApi.delete(`/mapping-ingredient/${id}`);
    return response.data;
  });
};
